import get from 'lodash/get';
import * as allFeedActions from '../../action_creators/homepage/all_feed_action_creators';
import AllFeedModel from '../../../models/homepage/all_feed_module';
import log from '../../../services/logger_service';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function allFeedAction(params, store) {
  return function allFeedDispatch(dispatch) {
    dispatch(allFeedActions.allFeedLoading(store));
    return AllFeedModel.fetch(params, store)
      .then(function handleAllFeedData(resp) {
        if (params.page && !get(resp, 'data.posts.length')) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }
        dispatch(allFeedActions.allFeedLoaded(resp.data, store));
      })
      .catch(function handleAllFeedError(err) {
        dispatch(allFeedActions.allFeedLoadError(err, store));
        log.error(err, `Error in all feed actions, message: ${err.message}`);
      });
  };
}
